import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slide, toast, ToastContainer as ToastifyToastContainer, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '../Icon/Icon';
import { ComponentTextSmall } from '../Typography/Typography';
import * as styles from './Notification.module.scss';
export const ToastContainer = ToastifyToastContainer;
const NotificationMessage = ({ title, icon }) => {
    return (_jsxs("div", { className: styles.message, children: [_jsx(Icon, { name: icon, className: "notification-icon" }), _jsx(ComponentTextSmall, { children: title })] }));
};
const mapMessageTypeToIcon = {
    warning: 'warning-enclosed-filled',
    error: 'x-enclosed-filled',
    success: 'checkmark-enclosed-filled',
    info: 'info-enclosed-filled',
};
const renderMessageFunction = {
    warning: toast.warning,
    error: toast.error,
    success: toast.success,
    info: toast.info,
};
/**
 * This utility requires an instance of <ToastContainer> to be rendered in the consuming app
 */
export const renderMessage = ({ content, type, duration, }) => {
    renderMessageFunction[type](() => (_jsx(NotificationMessage, { title: content, icon: mapMessageTypeToIcon[type] })), {
        position: 'top-center',
        autoClose: duration * 1000,
        draggable: false,
        hideProgressBar: true,
        closeButton: false,
        transition: Slide,
    });
};
